const initialState = {
  orderTotalUnread: 0,
  invoiceTotalUnread: 0,
  paymentTotalUnread: 0,
  debitTotalUnread: 0,
};

export default function unreadReducer(state = initialState, action) {
  switch (action.type) {
    case "SET_ORDER_TOTAL_UNREAD":
      return { ...state, orderTotalUnread: action.payload };
    case "SET_INVOICE_TOTAL_UNREAD":
      return { ...state, invoiceTotalUnread: action.payload };
    case "SET_PAYMENT_TOTAL_UNREAD":
      return { ...state, paymentTotalUnread: action.payload };
    case "SET_DEBIT_TOTAL_UNREAD":
      return { ...state, debitTotalUnread: action.payload };
    default:
      return state;
  }
}

// Action creators
export const setOrderTotalUnread = (count) => ({
  type: "SET_ORDER_TOTAL_UNREAD",
  payload: count,
});
export const setInvoiceTotalUnread = (count) => ({
  type: "SET_INVOICE_TOTAL_UNREAD",
  payload: count,
});
export const setPaymentTotalUnread = (count) => ({
  type: "SET_PAYMENT_TOTAL_UNREAD",
  payload: count,
});
export const setDebitTotalUnread = (count) => ({
  type: "SET_DEBIT_TOTAL_UNREAD",
  payload: count,
});
